import { wpFeSanitizeTitle } from "../utils/wpFeSanitizeTitle";


const { REACT_APP_PROGRAMS_URL } = process.env;

export const currentProgramUrl = (name?: string) =>
  name ? `${REACT_APP_PROGRAMS_URL}/${wpFeSanitizeTitle(name)}` : REACT_APP_PROGRAMS_URL
